import { make } from 'vuex-pathify'
import axios from 'axios'
import { getQueryFromFilter, showError } from '@/util/helpers'

const state = {
  icms: {},
  icmsList: {
    count: 0,
    data: [],
  },

  loading: false,
  filter: {
    itemsPerPage: 20,
  },
}

const mutations = make.mutations(state)

const actions = {
  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/icms?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.icmsList = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getByOriginDestination: async ({ state }, { origin, destination }) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/icms-origin-destination`, { origin, destination })
      .then(res => {
        state.icms = res.data
        console.log('ICMS', state.icms)
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
